import { handleActions } from 'redux-actions'
import * as publicActions from '../actions/public'

const initialState = {
  upcomingDays: {
    data: [],
    loading: false,
    failed: false,
    succeed: false
  },
  timeslots: {
    data: [],
    loading: false,
    failed: false,
    succeed: false
  },
  menu: {
    data: null,
    loading: false,
    failed: false,
    succeed: false
  },
  availableCategories: [],
  selectedCategoryId: 0
}

export default handleActions(
  {
    [publicActions.getUpcomingDays]: state => ({
      ...state,
      upcomingDays: {
        ...state.upcomingDays,
        loading: true,
        failed: false,
        succeed: false
      }
    }),
    [publicActions.getUpcomingDaysSuccess]: (state, action) => ({
      ...state,
      upcomingDays: {
        ...state.upcomingDays,
        data: action.payload,
        loading: false,
        succeed: true,
        failed: false
      }
    }),
    [publicActions.getUpcomingDaysFail]: (state, action) => ({
      ...state,
      upcomingDays: {
        ...state.upcomingDays,
        loading: false,
        succeed: false,
        failed: true
      }
    }),
    [publicActions.getTimeslots]: state => ({
      ...state,
      timeslots: {
        ...state.timeslots,
        loading: true,
        failed: false,
        succeed: false
      }
    }),
    [publicActions.getTimeslotsSuccess]: (state, action) => ({
      ...state,
      timeslots: {
        ...state.timeslots,
        data: action.payload,
        loading: false,
        succeed: true,
        failed: false
      }
    }),
    [publicActions.getTimeslotsFail]: (state, action) => ({
      ...state,
      timeslots: {
        ...state.timeslots,
        loading: false,
        succeed: false,
        failed: true
      }
    }),
    [publicActions.getMenu]: state => ({
      ...state,
      menu: {
        ...state.menu,
        loading: true,
        failed: false,
        succeed: false
      }
    }),
    [publicActions.getMenuSuccess]: (state, action) => {
      const menuData = action.payload
      const availableCategories =
        menuData && menuData.available && menuData.categories
          ? menuData.categories
              .map(category => {
                const { id, label } = category
                const meals = category.meals || []
                return {
                  id,
                  title: label,
                  meals: meals.length,
                  stock: meals.reduce(
                    (initialCount, currentMeal) =>
                      initialCount +
                      (currentMeal.stock < 0 ? 0 : currentMeal.stock),
                    0
                  )
                }
              })
              .filter(
                category => category.stock > 0 || [0, 13].includes(category.id)
              )
          : []

      const { selectedCategoryId } = state

      const newCategory =
        availableCategories.find(cat => cat.id === selectedCategoryId) ||
        availableCategories[0]

      return {
        ...state,
        menu: {
          ...state.menu,
          data: menuData,
          loading: false,
          succeed: true,
          failed: false
        },
        availableCategories,
        selectedCategoryId: newCategory ? newCategory.id : 0
      }
    },
    [publicActions.getMenuFail]: (state, action) => ({
      ...state,
      menu: {
        ...state.menu,
        data: null,
        loading: false,
        succeed: false,
        failed: true
      },
      availableCategories: [],
      selectedCategoryId: 0
    }),
    [publicActions.changeSelectedCategory]: (state, action) => ({
      ...state,
      selectedCategoryId: action.payload
    })
  },
  initialState
)



// WEBPACK FOOTER //
// ./src/store/reducers/public.js